import { render, staticRenderFns } from "./profileAttribute.vue?vue&type=template&id=21ba08e6&"
import script from "./profileAttribute.vue?vue&type=script&lang=js&"
export * from "./profileAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports